import * as React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import logoWebapp from '../../../resources/img/logo-new-small-webapp.png'
import { sections, Routes } from '../../../constants'
import { useSize } from '../../utils'
import { AppUtils, EstateUtils } from '../../../utils'
import { Profile } from '../..'
import { BetaRibbon, LinkLogo, Logo, Menu, MenuBackground, MenuButton, NavBar, ProfileMenu } from './TopBar.styles'
import EstateSwitcher from './EstateSwitcher'
import MenuItemSimple from './MenuItemSimple'
import UploadMedia from './UploadMedia'
import { useAppSelector } from '../../../reducers'
import { getSelectedEstateId } from '../../../reducers/app'

function TopBar({
    fullscreen,
    isIframe,
    onClickChangeLanguage,
    onClickConfigureDevice,
    onClickEstate,
    onClickLogout,
    onClickNavigateLog,
    onClickNavigateOperationsHub,
    onClickNavigateReports,
    pathname,
    username,
}) {
    const app = useAppSelector((state) => state.app)
    const estate = useAppSelector(getSelectedEstateId)
    const [isMobileMenuOpen, setMobileMenuOpen] = React.useState(false)
    const { isMobile } = useSize()

    const onClickLinkWrapper = () => {
        setMobileMenuOpen(false)
    }

    const renderMenuMobile = () => {
        return (
            <Menu>
                {sections.reduce((carry, menuProps) => {
                    const { acls, img, name, roles, route, submenu } = menuProps

                    if (app && !EstateUtils.hasPermission({ app }, { acls, roles })) {
                        return carry
                    }

                    const hasSubmenus = submenu && submenu.length;
                    const output = [...carry];

                    output.push(
                        <MenuItemSimple
                            key={name}
                            img={img}
                            name={name}
                            pathname={pathname}
                            route={hasSubmenus ? undefined : Routes.buildRoute(route, { estate })}
                            onClickLinkWrapper={hasSubmenus ? undefined : onClickLinkWrapper}
                        />
                    );

                    if (submenu && submenu.length) {
                        const submenuItems = submenu.reduce(
                            (subCarry, submenuProps) => {
                                const {
                                    acls: subAcl,
                                    highlight: subHighlight,
                                    name: subName,
                                    roles: subRoles,
                                    route: subRoute,
                                } = submenuProps;
                                const hasPermission = EstateUtils.hasPermission(
                                    { app },
                                    { acls: subAcl, roles: subRoles },
                                );

                                if (!hasPermission) {
                                    return subCarry;
                                }

                                return [
                                    ...subCarry,
                                    <MenuItemSimple
                                        key={`${name}-${subName}`}
                                        highlight={subHighlight}
                                        name={subName}
                                        onClickLinkWrapper={onClickLinkWrapper}
                                        pathname={pathname}
                                        route={Routes.buildRoute(subRoute, { estate })}
                                        isSubmenu
                                    />
                                ];
                            }, []);
                        
                            output.push(...submenuItems);
                    }

                    return output;
                }, [])}
            </Menu>
        )
    }

    const renderProfileMenu = () => {
        return (
            <ProfileMenu nopadding right nofit>
                <Profile
                    hideLogout={isIframe}
                    onClickChangeLanguage={onClickChangeLanguage}
                    onClickConfigureDevice={onClickConfigureDevice}
                    onClickLogout={onClickLogout}
                    onClickNavigateLog={onClickNavigateLog}
                    onClickNavigateOperationsHub={onClickNavigateOperationsHub}
                    onClickNavigateReports={onClickNavigateReports}
                    username={username}
                />
            </ProfileMenu>
        )
    }

    return (
        <>
            {!fullscreen && (
                <NavBar>
                    {isMobile && (
                        <>
                            <MenuButton
                                onClick={() => setMobileMenuOpen(isOpen => !isOpen)}
                                isMobileMenuOpen={isMobileMenuOpen}
                            >
                                <FontAwesomeIcon icon="bars" />
                            </MenuButton>
                            {renderMenuMobile()}
                            {renderProfileMenu()}
                            <EstateSwitcher onChangeEstate={onClickEstate} />
                            {isMobileMenuOpen && (
                                <MenuBackground onClick={() => setMobileMenuOpen(false)} />
                            )}
                        </>
                    )}
                    {!isMobile && (
                        <>
                            <LinkLogo to={Routes.ROOT}>
                                {AppUtils.isStaging() && <BetaRibbon>Staging</BetaRibbon>}
                                <Logo src={logoWebapp} />
                            </LinkLogo>
                            <EstateSwitcher onChangeEstate={onClickEstate} />
                            {renderProfileMenu()}
                            <UploadMedia/>
                        </>
                    )}
                </NavBar>
            )}
        </>
    )
}

TopBar.propTypes = {
    fullscreen: PropTypes.bool,
    history: PropTypes.shape({}).isRequired,
    isIframe: PropTypes.bool,
    onClickChangeLanguage: PropTypes.func,
    onClickConfigureDevice: PropTypes.func,
    onClickEstate: PropTypes.func,
    onClickLogout: PropTypes.func,
    onClickNavigateLog: PropTypes.func,
    onClickNavigateOperationsHub: PropTypes.func,
    onClickNavigateReports: PropTypes.func,
    pathname: PropTypes.string.isRequired,
    selectedEstate: PropTypes.string,
    username: PropTypes.string,
}

TopBar.defaultProps = {
    fullscreen: false,
    isIframe: false,
    onClickChangeLanguage: () => null,
    onClickConfigureDevice: () => null,
    onClickEstate: () => null,
    onClickLogout: () => null,
    onClickNavigateLog: () => null,
    onClickNavigateOperationsHub: () => null,
    onClickNavigateReports: () => null,
    selectedEstate: null,
    username: null,
}

export default TopBar
